import React, { FC, useContext } from 'react'
import { BlueConicConfigurationContext } from '../../configuration/context'
import { Input, Select } from 'antd'
import { RelativeDateFilterValueBuilder } from './relative-date-value-builder'
import { SpecificDateFilterValueBuilder } from './specific-date-value-builder'
import { Filter, RelativeDateFilter, SpecificDateFilter } from '../types'
import { ConditionOperatorType, FilterType } from '../enums'
import { simpleDateFormat } from '../helpers'
import classnames from 'classnames'
import { EditableViewContext } from '@pushly/aqe/lib/components/hoc/editable-view/editable-view-context'

type RelativeOrSpecificDateFilterProps = {
    filter: SpecificDateFilter | RelativeDateFilter
    onChange: (value: Filter) => void
}

export const RelativeOrSpecificDateFilter: FC<RelativeOrSpecificDateFilterProps> = ({ filter, onChange }) => {
    const ctxView = useContext(EditableViewContext)
    const context = useContext(BlueConicConfigurationContext)

    return (
        <div className="blueconic-date-filter">
            <Input.Group size="default" compact>
                <span className={`ant-input-group-addon middle-size`}>when</span>
                <Select<FilterType.RELATIVE_DATE | FilterType.SPECIFIC_DATE>
                    className={classnames(ctxView.modeClassName, 'blueconic-date-filter-type-select')}
                    size="middle"
                    options={[
                        { value: FilterType.RELATIVE_DATE, label: 'relative dates' },
                        { value: FilterType.SPECIFIC_DATE, label: 'specific date' },
                    ]}
                    value={filter.filterType}
                    onChange={(v) => {
                        onChange({
                            ...filter,
                            filterType: v,
                            value:
                                v === FilterType.SPECIFIC_DATE
                                    ? {
                                          operator: ConditionOperatorType.EQUALS,
                                          value: simpleDateFormat(new Date()),
                                          meta: {
                                              timezone: context.domain.timezone,
                                          },
                                      }
                                    : {
                                          operator: ConditionOperatorType.LTE,
                                          value: 7,
                                          meta: {
                                              timezone: context.domain.timezone,
                                              qualifier: 'days',
                                          },
                                      },
                        } as RelativeDateFilter | SpecificDateFilter)
                    }}
                />

                {filter.filterType === FilterType.RELATIVE_DATE && (
                    <RelativeDateFilterValueBuilder filter={filter} onChange={onChange} />
                )}

                {filter.filterType === FilterType.SPECIFIC_DATE && (
                    <SpecificDateFilterValueBuilder filter={filter} onChange={onChange} />
                )}
            </Input.Group>
        </div>
    )
}
